// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2IbYU","buttonText":"styles_buttonText__2oEla","buttonArrow":"styles_buttonArrow__33ePO"};